/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedStatements } from '../block_compatibility_checks';
import { AreaService } from '@/services/area.service';


Blockly.Blocks['input_glacier_data'] = {
  init: function () {
    let areas = AreaService.getAreas();
    this.appendDummyInput()
      .appendField('Glacier Data: ')
      .appendField(new Blockly.FieldDropdown([
        ["Petermann ERS", 'leeds_PG_ERS'],
        ["Petermann Velocity", 'leeds_PG_Velocity'],
        ["Jakobshavn Velocity", 'leeds_JAK_Velocity']
      ]), "param")
    this.appendDummyInput('inp')
      .appendField("Area: ", 'area_text')
      .appendField(new Blockly.FieldDropdown(areas), "area")
    this.appendStatementInput("do")
      .setCheck(getAllowedStatements('glacier'))

    this.setInputsInline(false);
    this.setStyle('terrain');
    this.setTooltip("Glacier data selection block. ");
    this.setHelpUrl("");
  }
};
